var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.styles.circle(_vm.targetGroup, _vm.group, _vm.isTargetGroup)})])
}
var staticRenderFns = []

export { render, staticRenderFns }